import { CheckoutContext } from '@/contexts/CheckoutContext';
import { useContext } from 'react';

export const useCouponDiscount = () => {
  const { applyCouponValue: shouldApplyCoupon, couponData = { discount: 0, applyOnBumps: false } } =
    useContext(CheckoutContext);

  const applyCoupon = (price: number, bump: boolean = false) => {
    return price - getDiscount(price, bump);
  };

  const getDiscount = (price: number, bump: boolean = false) => {
    if (!shouldApplyCoupon || (bump && !couponData?.applyOnBumps)) {
      return 0;
    }
    return (couponData.discount * price) / 100;
  };

  return {
    applyCoupon,
    getDiscount
  };
};
